// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__6NU0a","modal":"style_modal__GQBVd","close":"style_close__fo41Q"};